function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);

  if (document.body.classList.contains('template--product')) {
    const elmOptionSelectedWidth = summary.querySelector('.selected-option ').offsetWidth;
    Array.from(summary.closest('.accordion__details').querySelectorAll('.variant-options-list li')).forEach((elm) => {
      if (elm) {
        elm.style.width = elmOptionSelectedWidth + 'px';
      }
    });
  }
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');

      const firstItem = document.querySelectorAll('.mobile-facets .mobile-facets__details')[0];
      if (firstItem) {
        firstItem.setAttribute('open', true);
        firstItem.querySelector('.mobile-facets__summary').setAttribute('aria-expanded', true);
      }
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    this.calculateLeft();
    let self = this;
    window.addEventListener('resize', function () {
      self.calculateLeft();
    });
  }

  calculateLeft() {
    this.querySelectorAll('.media-extend-mobile').forEach((item) => {
      let position = Number(item.getAttribute('data-position'));
      let marginRight = 8;
      let left = 9;
      let widthMediaMain = Number(this.querySelector('.slider--mobile').querySelector('li').offsetWidth);
      let widthItem = item.offsetWidth;
      let leftItem = (position - 1) * widthMediaMain + (position - 1) * marginRight + left;
      console.log('widthMediaMain', widthMediaMain);
      console.log('leftItem', leftItem);
      item.style.left = leftItem + 'px';
      item.classList.remove('hidden');
    });
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.querySelector('.announcement-bar-slider')) {
      this.announcementBarArrowButtonWasClicked = false;

      this.desktopLayout = window.matchMedia('(min-width: 750px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      [this.reducedMotion, this.desktopLayout].forEach((mediaQuery) => {
        mediaQuery.addEventListener('change', () => {
          if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
        });
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked || !this.desktopLayout.matches
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked &&
      this.desktopLayout.matches
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.querySelector('.announcement-bar-slider').contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.onVariantChange.bind(this));

    this.updateMasterId();
  }

  onVariantChange(event) {
    if (event.target.classList.contains('variant-option-button')) {
      this.updateOptions(event.target);
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantStatuses();
      // this.updateStock();
      this.updateSlides();
      if (window.innerWidth >= 768) {
        this.renderMetafieldExtra(event.target);
      }

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
        this.updateShareUrl();
      }
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      if (document.querySelector('.lightbox-inner-img-container')) {
        document.querySelector('.lightbox-inner-img-container').innerHTML = '';
      }
    }
  }

  async renderMetafieldExtra(selectedButton) {
    const extraImageFunctionality = new Headers();
    extraImageFunctionality.append('Content-Type', 'application/json');
    extraImageFunctionality.append('X-Shopify-Storefront-Access-Token', 'c88818657af8fb01e9e9d97631734fb2');
    const DOMAIN = 'hannun.myshopify.com';
    let containerExtra = document.querySelector('.swiper-media-gallery');
    containerExtra.querySelectorAll('.media-extend-wrap').forEach((el) => el.remove());
    const variantLi = selectedButton.closest('li[data-handles]');
    if (!variantLi) return;

    const handlesString = variantLi.getAttribute('data-handles');
    if (!handlesString) return;

    const handles = handlesString.split(',');

    function extractPlainTextFromRichText(richTextJson) {
      try {
        const obj = JSON.parse(richTextJson);
        let text = '';

        if (obj && obj.children && Array.isArray(obj.children)) {
          obj.children.forEach((child) => {
            if (child.children && Array.isArray(child.children)) {
              child.children.forEach((grandChild) => {
                if (grandChild.value) {
                  text += grandChild.value + '\n';
                }
              });
            }
          });
        }

        return text.trim();
      } catch (e) {
        console.warn('Error parsing rich text JSON:', e);
        return richTextJson; // fallback
      }
    }

    async function fetchMediaImage(gid) {
      const graphql = JSON.stringify({
        query: `
        query {
          node(id: "${gid}") {
            ... on MediaImage {
              image {
                originalSrc
              }
            }
          }
        }
      `,
        variables: {},
      });

      const res = await fetch(`https://${DOMAIN}/api/2024-04/graphql.json`, {
        method: 'POST',
        headers: extraImageFunctionality,
        body: graphql,
      });

      const data = await res.json();
      return data.data.node?.image?.originalSrc || null;
    }

    const languageExtraImageFunctionality = localStorage.getItem('localeLS').toUpperCase();
    async function fetchMetaobject(handle) {
      console.log('Procesando handle:', handle);
      const graphql = {
        query: `
        query getMetaobject($handleInput: MetaobjectHandleInput!) @inContext(language: ${languageExtraImageFunctionality}) {
          metaobject(handle: $handleInput) {
            id
            fields {
              key
              value
            }
          }
        }
      `,
        variables: {
          handleInput: {
            handle: handle,
            type: 'extra_image_functionality',
          },
        },
      };

      const res = await fetch(`https://${DOMAIN}/api/2024-04/graphql.json`, {
        method: 'POST',
        headers: extraImageFunctionality,
        body: JSON.stringify(graphql),
      });

      const json = await res.json();
      return json.data?.metaobject || null;
    }

    async function processMetaobject(handle) {
      const metaobject = await fetchMetaobject(handle);
      if (!metaobject) return '';

      const fields = {};
      metaobject.fields.forEach((f) => (fields[f.key] = f.value));

      let imageUrl = null;
      if (fields.media) {
        imageUrl = await fetchMediaImage(fields.media);
      }

      let html = `
        <div data-position="${fields.main_photo_location || ''}"
          class="media-extend-wrap media-extend-item media-desktop-${fields.position || ''}"
          style="display: flex !important;">
      `;

      html += `
          <div class="title-extend">
            ${extractPlainTextFromRichText(fields.title) || ''}
          </div>
          ${
            imageUrl
              ? `<img src="${imageUrl}" loading="lazy" alt="img extend" class="img_extend" />`
              : `<div class="img-empty"></div>`
          }
        </div>
      `;

      return html;
    }

    const htmlParts = await Promise.all(handles.map((handle) => processMetaobject(handle.trim())));
    await new Promise((resolve) => setTimeout(resolve, 1000));

    containerExtra = document.querySelector('.swiper-media-gallery');

    if (containerExtra) {
      containerExtra.innerHTML += htmlParts.join('');
      this.calculateTop();
    } else {
      console.warn('No se encontró .swiper-media-gallery al insertar el contenido extendido');
    }
  }

  calculateTop() {
    document.querySelectorAll('.media-extend-item').forEach((item) => {
      let position = Number(item.getAttribute('data-position'));
      let marginBottom = 8;
      if (window.screen.width >= 750) {
        marginBottom = 40;
      }
      let heightPlus = (position - 1) * marginBottom;
      item.classList.remove('hidden');
      let heightItem = Number(item.offsetHeight);
      let heightMediaMain = 0;
      if (heightMediaMain == 0) {
        heightMediaMain = 700;
      }
      let top = heightMediaMain * position + heightPlus - heightItem;
      item.style.top = top + 'px';
    });
  }

  updateOptions(selectedButton) {
    const selectedValue = selectedButton.getAttribute('data-value');
    const parentDetails = selectedButton.closest('.accordion__details');
    const optionIndex = Array.from(this.querySelectorAll('.accordion__details')).indexOf(parentDetails);

    // Get all options based on the selected value
    this.options =
      this.options ||
      Array.from(this.querySelectorAll('.accordion__details'))
        .map((details) => {
          const selected = details.querySelector('.variant-option-button[aria-selected="true"]');
          return selected ? selected.getAttribute('data-value') : null;
        })
        .filter((value) => value !== null);

    this.options[optionIndex] = selectedValue;
    if (selectedButton.closest('.accordion__details')) {
      selectedButton.closest('.accordion__details').removeAttribute('open');
    }
  }

  updateMasterId() {
    console.log(this.options);
    if (this.options) {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });

      const colorActive = this.currentVariant.option1;
      // if (colorActive) {
      //   Array.from(document.querySelectorAll('.product__media-item.comes-variant')).forEach((e) => {
      //     if (e.getAttribute('data-variant-option-color') !== colorActive) {
      //       e.classList.add('non-swiper-slide');
      //       e.style.display = 'none';
      //     } else {
      //       e.classList.remove('non-swiper-slide');
      //       e.style.display = 'block';
      //     }
      //   });

      //   const swiperGallery = document.querySelector('.slider-mobile-gutter--custom media-gallery-swiper .swiper');
      //   if (swiperGallery) {
      //     const swiperOptions = {
      //       direction: 'vertical',
      //       loop: false,
      //       slidesPerView: 'auto',
      //       speed: 500,
      //       mousewheel: {
      //         releaseOnEdges: true,
      //       },
      //       breakpoints: {
      //         750: {
      //           scrollbar: {
      //             el: this.querySelector('.swiper-scrollbar'),
      //             draggable: true,
      //             dragSize: 183,
      //           },
      //         },
      //       },
      //     };
      //     const swiper = new Swiper(swiperGallery, swiperOptions);
      //     swiper.update();
      //   }
      // }
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    // if (window.innerWidth <= 768) {
    //   location.reload();
    // }
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) =>
        this.querySelector('.variant-option-button[aria-selected="true"]').getAttribute('data-value') ===
        variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.accordion__details')];
    inputWrappers.forEach((details, index) => {
      if (index === 0) return;
      const optionInputs = [...details.querySelectorAll('.variant-option-button')];
      const previousOptionSelected = inputWrappers[index - 1]
        .querySelector('.variant-option-button[aria-selected="true"]')
        .getAttribute('data-value');
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('data-value'))) {
        input.innerText = input.getAttribute('data-value');
        input.removeAttribute('disabled');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          '[value]',
          input.getAttribute('data-value')
        );
        input.setAttribute('disabled', 'true');
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        const productTextShipping = html.getElementById(`ProductInfoShipping-${sectionId}`);
        const productTextShippingEle = document.getElementById(`ProductInfoShipping-${this.dataset.section}`);
        if (productTextShippingEle && productTextShipping) {
          productTextShippingEle.innerHTML = productTextShipping.innerHTML;
          // this.updateStock();
        }

        const productIntruction = html.getElementById(`product-intruction-variant-${sectionId}`);
        const productIntructionEle = document.getElementById(`product-intruction-variant-${this.dataset.section}`);
        if (productIntructionEle && productIntruction) {
          productIntructionEle.innerHTML = productIntruction.innerHTML;
        }

        const productDimensiones = html.getElementById(`product-dimensiones-variant-${sectionId}`);
        const productDimensionesEle = document.getElementById(`product-dimensiones-variant-${this.dataset.section}`);
        if (productDimensionesEle && productDimensiones) {
          productDimensionesEle.innerHTML = productDimensiones.innerHTML;
        }

        const mediaSource = html.querySelector('.product__media-list media-gallery-swiper');
        const mediaDestination = document.querySelector('.product__media-list media-gallery-swiper');

        if (mediaSource && mediaDestination) {
          mediaDestination.innerHTML = mediaSource.innerHTML;
          const swiperGallery = document.querySelector('.slider-mobile-gutter--custom media-gallery-swiper .swiper');
          if (swiperGallery) {
            const swiperOptions = {
              direction: 'vertical',
              loop: false,
              slidesPerView: 'auto',
              speed: 500,
              mousewheel: {
                releaseOnEdges: true,
              },
              touchReleaseOnEdges: true,
              scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true,
                dragSize: 90,
                hide: false,
              },
              breakpoints: {
                750: {
                  scrollbar: {
                    el: this.querySelector('.swiper-scrollbar'),
                    draggable: true,
                    dragSize: 183,
                  },
                },
              },
            };
            const swiper = new Swiper(swiperGallery, swiperOptions);
            swiper.update();
          }
        }

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updateSlides() {
    let selectedVariant = document.querySelector('.variant-option-button[aria-selected="true"]');
    if (!selectedVariant) return;

    let matchingVariant = this.getVariantData();
    if (!matchingVariant) return;

    let variantId = parseInt(this.currentVariant.id);

    let slides = document.querySelectorAll('.media-extend-wrap');

    slides.forEach((slide) => {
      let dataVariantId = parseInt(slide.getAttribute('data-variant-id'));
      if (dataVariantId !== variantId) {
        slide.classList.add('hidden');
      } else {
        slide.classList.remove('hidden');
      }
    });
  }
}
customElements.define('variant-selects', VariantSelects);

class ShippingLabel extends HTMLElement {
  static observedAttributes = ['iso-code', 'has-stock', 'prod-days'];
  constructor() {
    super();
  }

  connectedCallback() {
    this.hasStock = Number(this.getAttribute('has-stock'));
    this.prodDays = Number(this.getAttribute('prod-days'));

    this.shippingLabel = window.variantStrings.start_from;
    this.shippingLabelAlt = window.variantStrings.start_from_alt;
    this.monthsStrings = window.variantStrings.months;
    this.estimatedShippingSpan = this.querySelector('#estimated-shipping-date');
    this.calculateShipping(this.hasStock, this.prodDays);
  }

  calculateShipping(hasStock, productionDays) {
    const isoCode = this.getAttribute('iso-code') || 'ES';
    const estimateShipping = new EstimateShippingDate();
    const { result, weekEnd, weekStart } = estimateShipping.calculateShipping(hasStock, productionDays);
    this.setAttribute('estimated-date', result);

    let weekStartDay = weekStart.getDate();
    let weekEndDay = weekEnd.getDate();

    const weekStartMonth = weekStart.getMonth();
    const weekEndMonth = weekEnd.getMonth();

    let label = this.shippingLabel;

    if (isoCode === 'EN' || isoCode === 'en') {
      weekStartDay = this.formatEnglishDay(weekStartDay);
      weekEndDay = this.formatEnglishDay(weekEndDay);
    }

    if (weekStartMonth === weekEndMonth) {
      const m = weekStartMonth.toString().replace(/\.0+$/, '');

      label = label.replace('__first__', weekStartDay);
      label = label.replace('__last__', weekEndDay);
      label = label.replace('__month__', this.monthsStrings[m]);
    } else {
      label = this.shippingLabelAlt;
      const fm = weekStartMonth.toString().replace(/\.0+$/, '');
      const lm = weekEndMonth.toString().replace(/\.0+$/, '');

      label = label.replace('__first__', weekStartDay);
      label = label.replace('__last__', weekEndDay);
      label = label.replace('__fmonth__', this.monthsStrings[fm]);
      label = label.replace('__lmonth__', this.monthsStrings[lm]);
    }
    console.log('label', label);
    if (this.estimatedShippingSpan) {
      this.estimatedShippingSpan.innerHTML = label;
    }
  }

  addWorkingDays(startDate, daysToAdd) {
    const result = new Date(startDate);
    let addedDays = 0;

    while (addedDays < daysToAdd) {
      result.setDate(result.getDate() + 1);
      if (result.getDay() !== 0 && result.getDay() !== 6) {
        addedDays++;
      }
    }

    return result;
  }
  getWeekStart(date) {
    const result = new Date(date);
    const dayOfWeek = result.getDay();
    const daysToMonday = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
    result.setDate(result.getDate() + daysToMonday);
    return result;
  }
  getWeekEnd(date) {
    const result = new Date(date);
    const dayOfWeek = result.getDay();
    const daysToFriday = dayOfWeek === 0 ? -2 : 5 - dayOfWeek;
    result.setDate(result.getDate() + daysToFriday);
    return result;
  }

  formatEnglishDay(day) {
    if ((day === 1, day === 21 || day === 31)) {
      return day + 'st';
    } else if (day === 2 || day === 22) {
      return day + 'nd';
    } else if (day === 3 || day === 23) {
      return day + 'rd';
    } else {
      return day + 'th';
    }
  }
}

customElements.define('estimated-shipping-label', ShippingLabel);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // const handleIntersection = (entries, observer) => {
    //   if (!entries[0].isIntersecting) return;
    //   observer.unobserve(this);

    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
        this.initSwiper();
      })
      .catch((e) => {
        console.error(e);
      });
    // };

    // new IntersectionObserver(handleIntersection.bind(this), {
    //   rootMargin: '0px 0px 400px 0px',
    // }).observe(this);
  }

  initSwiper() {
    try {
      new Swiper(this.querySelector('.related__items'), {
        slidesPerView: 'auto',
        spaceBetween: 8,
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          clickable: true,
        },
        scrollbar: {
          el: this.querySelector('.swiper-scrollbar'),
          draggable: true,
          dragSize: 100,
        },
        mousewheel: {
          forceToAxis: true,
        },
        breakpoints: {
          750: {
            spaceBetween: 8,
            scrollbar: {
              dragSize: 348,
            },
          },
        },
      });
    } catch (error) {
      console.error(error);
    }
  }
}

customElements.define('product-recommendations', ProductRecommendations);
if (document.querySelector('.modal_product_combinations-header-close_combinations')) {
  document.querySelector('.modal_product_combinations-header-close_combinations').addEventListener('click', () => {
    const modal = document.querySelector('.modal_product__combinations');
    modal.classList.remove('show_modal');
    modal.classList.add('hide_modal');
  });
}
document.addEventListener('DOMContentLoaded', function () {
  const drawerSwitch = document.getElementById('layout-switch-cart-view');
  const drawerElement = document.getElementById('CartDrawer');
  const wishlistElement = document.getElementById('swym-custom-in-drawer');

  drawerSwitch.addEventListener('click', function () {
    if (drawerElement) {
      drawerElement.style.display = 'block';
    }
    if (wishlistElement) {
      wishlistElement.style.display = 'none';
    }
  });
  setTimeout(() => {
    const swym = document.getElementById('swym-plugin');
    if (swym) {
      swym.addEventListener('click', (e) => {
        window.location.href = '/cart?select=wishlist';
      });
    }
  }, 3000);
  let imageUrls = [];
  let currentIndex = 0;
  let totalImages = 0;
  let swiper_lightbox = '';
  document.addEventListener('click', (event) => {
    let lightboxModal = document.getElementById('rocket-lightbox-modal');
    if (!lightboxModal) return;
    let lightboxContent = lightboxModal.querySelector('.lightbox-content');
    const lightboxControl = lightboxModal.querySelector('.lightbox-inner');
    const lighBoxFrameContainer = lightboxModal.querySelector('.lightbox-inner-img-container');
    const generalFrameContainer = document.querySelector('.marco-wrapper');

    if (generalFrameContainer) {
      const attr = generalFrameContainer.querySelector('.product-img-marco').getAttribute('data-marco');
      lighBoxFrameContainer.setAttribute('data-marco', attr);
    }

    const closeBtn = lightboxModal.querySelector('.lightbox-close');
    const prevBtn = lightboxModal.querySelector('.lightbox-prev');
    const nextBtn = lightboxModal.querySelector('.lightbox-next');
    if (event.target.classList.value.indexOf('media__trigger') > -1) {
      const images = document.querySelectorAll('.media__trigger');
      imageUrls = Array.from(images).map((img) => img.getAttribute('src').split('?')[0]);
      totalImages = imageUrls.length;

      images.forEach((img, index) => {
        if (event.target.contains(img)) {
          currentIndex = index;
          openLightbox();
          document.body.classList.add('lightbox-open');
        }
      });
    }
    // if (event.target.contains(prevBtn)) {
    //   currentIndex = (currentIndex - 1 + totalImages) % totalImages;
    //   updateLightbox();
    // }
    // if (event.target.contains(nextBtn)) {
    //   currentIndex = (currentIndex + 1) % totalImages;
    //   updateLightbox();
    // }
    if (event.target.contains(closeBtn)) {
      lightboxModal.style.display = 'none';
      document.body.classList.remove('lightbox-open');
    }
    if (event.target.contains(lightboxModal)) {
      lightboxModal.style.display = 'none';
      document.body.classList.remove('lightbox-open');
    }
    function openLightbox() {
      lightboxControl.classList.add('loading');
      updateLightbox();
      lightboxModal.style.display = 'flex';
    }

    function updateLightbox() {
      // lightboxContent.src = imageUrls[currentIndex];

      // Update the data-marco attribute conditionally
      if (currentIndex === 0 && generalFrameContainer) {
        const attr = generalFrameContainer.querySelector('.product-img-marco')?.getAttribute('data-marco');
        if (attr) {
          lighBoxFrameContainer.setAttribute('data-marco', attr);
        }
      } else {
        lighBoxFrameContainer.removeAttribute('data-marco');
      }

      // lightboxContent.onload = function () {
      //   if (lightboxControl.classList.contains('loading')) {
      //     lightboxControl.classList.remove('loading');
      //   }
      // };

      let htmlImage = '';
      imageUrls.forEach((v, i) => {
        htmlImage += `
          <div class="item-image swiper-slide">
              <img src="${imageUrls[i]}" class="lightbox-item-image__zoom" />
          </div>
        `;
      });

      if (lighBoxFrameContainer) {
        lighBoxFrameContainer.innerHTML = htmlImage;
        if (swiper_lightbox != '') {
          if (lightboxControl.classList.contains('loading')) {
            document.querySelector('.lightbox-item-image__zoom').onload = function () {
              lightboxControl.classList.remove('loading');
            };
          }
          if (lighBoxFrameContainer.innerHTML != '') {
            swiper_lightbox.slideTo(currentIndex);
          } else {
            swiper_lightbox.update();
          }
        } else {
          swiper_lightbox = new Swiper(document.querySelector('.lightbox-inner .swiper'), {
            loop: false,
            slidesPerView: 1,
            mousewheel: {
              forceToAxis: true,
              releaseOnEdges: true,
              sensitivity: 1,
              thresholdDelta: 40,
              thresholdTime: 200,
            },
            navigation: {
              nextEl: document.querySelector('.lightbox-next'),
              prevEl: document.querySelector('.lightbox-prev'),
            },
            on: {
              init: function () {
                this.slideTo(currentIndex);
                if (lightboxControl.classList.contains('loading')) {
                  document.querySelector('.lightbox-item-image__zoom').onload = function () {
                    lightboxControl.classList.remove('loading');
                  };
                }
              },
            },
          });
        }
      }
    }
    if (event.target.matches('.lightbox-item-image__zoom')) {
      event.target.closest('.lightbox-inner').classList.toggle('zoom');
    }
  });
});

function switchToWishListView() {
  const drawerElement = document.getElementById('CartDrawer');
  const wishlistElement = document.getElementById('swym-custom-in-drawer');
  if (drawerElement) {
    drawerElement.style.display = 'none';
  }
  if (wishlistElement) {
    wishlistElement.style.display = 'block';
  }
}
class videoPopup extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.videoPopup();
  }

  videoPopup() {
    const btnOpenPopup = this.querySelector('.btn-open-video-popup');
    const btnClosePopup = this.querySelector('.btn-close-video-popup');
    const contentPopup = this.querySelector('.content-popup');
    const videoPopup = this.querySelector('video');
    btnOpenPopup.addEventListener('click', function () {
      btnOpenPopup.classList.add('hidden');
      contentPopup.classList.remove('hidden');
      videoPopup.play();
      videoPopup.controls = true;
      btnOpenPopup.closest('.elm-video-popup').classList.add('open');
      document.body.classList.add('fix');
    });
    btnClosePopup.addEventListener('click', function () {
      btnOpenPopup.classList.remove('hidden');
      contentPopup.classList.add('hidden');
      videoPopup.pause();
      btnClosePopup.closest('.elm-video-popup').classList.remove('open');
      document.body.classList.remove('fix');
    });
  }
}

customElements.define('video-popup', videoPopup);

class RocketSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.initSwiper();
        }
      });
    });
  }

  connectedCallback() {
    this.observer.observe(this);
  }

  initSwiper() {
    if (this.swiper) this.swiper.destroy();
    const sliderIdentifier = this.dataset.id;
    let perPage = this.dataset.row;
    let space = this.dataset.space;
    let perPageMb = this.dataset.rowMb;
    let spaceMB = this.dataset.spaceMb;

    this.swiper = new Swiper(`[data-id="${sliderIdentifier}"]`, {
      slidesPerView: perPageMb,
      spaceBetween: spaceMB,
      loop: false,
      mousewheel: { forceToAxis: true },
      freeMode: true,
      allowTouchMove: true,
      touchMoveStopPropagation: false,
      breakpoints: {
        768: {
          slidesPerView: 5.61,
          spaceBetween: 8,
        },
        1024: {
          slidesPerView: perPage,
          spaceBetween: space,
        },
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
        hide: false,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
    this.observer.disconnect();
  }
}

customElements.define('rocket-slider', RocketSlider);
